require('./line-settings-template.html');
require('common/modals/number-voiceover-template.html');
require('./line-settings.modal.copy-settings-template.html');
require('./line-settings.modal.confirm-delete-template.html');

var uploadHeaders = {
  transformRequest: angular.identity,
  headers: { 'Content-Type': undefined },
};

angular.module('bbl.module.line-settings.controller', [])
  .controller('LineSettingsController', [
    '$scope', '$route', 'Api', '$window', '$http', '$timeout', '$compile', 'bridge', 'Toast', '$location', 'userInfo', 'CallManager', 'modals',
    LineSettingsController
  ]);

function LineSettingsController($scope, $route, Api, $window, $http, $timeout, $compile, bridge, Toast, $location, userInfo, CallManager, modals) {
  $scope.MODEL = angular.extend({}, bridge);
  $scope.LOADED = true;
  $scope.number = $scope.MODEL.bridge_number;

  $scope.pinlist_loading = false;
  $scope.pinlist_file = null;
  $scope.pinlist_uploadError = null;
  $scope.pinlist_showModal = function() {
    $scope.pinlist_modal = modals.importPinList($scope).modal();
  };

  var company = userInfo.company || {};
  $scope.pinlist_showImport = ['5718', '43', '7776', '8730'].indexOf(company.id+'') > -1;
  $scope.disableRecordings = company.recordings_disabled;
  $scope.enablePlaybackModeOption = !(userInfo.plan.unlimited || userInfo.plan.trial_period_days);

  $scope.copyFrom = 'Select bridge line';
  $scope.selectedCopyFrom = false;
  $scope.voiceover_config = {step: 0};

  $scope.INFO = {
    voiceover: '',
    voiceoverSave: false
  };

  var conflictToast;

  var checkConflictConfig = function(newVal, oldVal) {
    if (!$scope.MODEL.seminar || !$scope.MODEL.announce_names || $scope.MODEL.announce_names !== $scope.MODEL.seminar) {
      return;
    }

    if (conflictToast) {
      conflictToast.remove();
    }

    var isSaved = newVal === oldVal;

    if (!isSaved) {
      $scope.MODEL.announce_names = !oldVal[0];
      $scope.MODEL.seminar = !oldVal[1];
    }

    conflictToast = Toast.error('Please note! <br> <small><strong>Record & announce caller names</strong></small> and <small><strong>Seminar / Lecture mode</strong></small> can\'t be checked at the same time!', {
      persistent: isSaved
    });
  };

  // $scope.$watch('[MODEL.announce_names, MODEL.seminar]', checkConflictConfig);

  CallManager.init(userInfo.plivo_username, userInfo.plivo_password);
  $scope.makeCall = CallManager.createCall.bind(0, $scope.MODEL);

  $scope.playVoiceSample = function($event, artist) {
    $event.preventDefault();
    var sampleURL =  artist.sample_file_url || artist.sample_file;

    $scope.voiceSampleElement = (function(url){
      var audioElement = $scope.voiceSampleElement || $('<audio>').get(0);
      audioElement.src = url;
      audioElement.load();
      return audioElement;
    })(sampleURL);

    $scope.voiceSampleElement.play();
  };

  $scope.saveVoiceOverData = function() {
    var data = $.param({
      number: $window.localStorage.buyNumber,
      voiceover: $scope.INFO.voiceover,
      artist_id: $scope.INFO.artist_id
    });

    $http.post('/bridges/api/v1/set-voiceover', data, {
      headers : {'Content-Type': 'application/x-www-form-urlencoded'},
    }).then(function() {
      $window.localStorage.setItem('greeting_requested', true);
    }, function() {
      console.log("error config number");
    });
  };

  // Get all bridges information, used for copy line settings.
  Api.bridges.sub(function(bridges) { $scope.bridges = bridges; });
  Api.bridges.fetch({limit: 100});

  var showDeleteLineModal = function () {
    $('#confrimDeleteLine').modal('show');
  };

  $scope.deleteTiedLine = function (line) {
    $http.post('/bridges/api/v1/delete-did/'+line.id+'/', {}).then(function() {
      $scope.MODIFIED = false;
      Api.bridges.fetch({limit: 100}, {cache: false}).then($location.path.bind($location, '/dashboard'));
    }, function() {
      Toast.error("{{'There was an error deleting the line'|translate}}!");
    });
  };

  $scope.doDeleteLine = function () {
    $http.get('/bridges/api/v1/delete_bridge/' + bridge.id + "/").then(function() {
      $scope.MODIFIED = false;
      $scope.hideModal('confrimDeleteLine');
      Api.bridges.fetch({limit: 100}, {cache: false}).then($location.path.bind($location, '/dashboard'));
    }, function() {
      $scope.hideModal('confrimDeleteLine');
      Toast.error("{{'There was an error deleting the line'|translate}}!");
    });
  };

  /**
   * Submit the form to the PUT call.
   * Save the state on SUBMITED var to show the loader.
   */
  $scope.submitForm = function() {
    if($scope.MODEL.deleteLine) {
      return showDeleteLineModal();
    }

    if ($scope.MODEL.seminar && !$scope.MODEL.moderated) {
      return Toast.error("{{'In order to use Seminar / Lecture mode, you must use a moderator PIN'|translate}}");
    }

    $scope.SUBMITED = true;

    Api.bridges.update(bridge.id, $scope.MODEL)
    .then(Api.bridges.fetch.bind(Api.bridges, {limit: 100}, {cache: false}))
    .then(function(response) {
      angular.extend($scope.MODEL, response.objects.filter(function(b) {
        return b.id === $scope.MODEL.id;
      })[0] || {});
      setTimeout(function() { $scope.MODIFIED = false; });

      $scope.SUBMITED = false;

      $scope.goNext();
      Toast.notify('Changes successfully saved!');
      if (conflictToast) {
        conflictToast.remove();
      }
    });
  };

  /**
   * Change the placeholder of the text when the welcome option is changed.
   * We are using the the same text field for the welcome options.
   */
  $scope.$watch('MODEL.welcome_option', function (val) {
    if(val == 'R') {
      $scope.placeholder_text = "Welcome to the conference line. Your conference will begin shortly. In the meantime, enjoy some tunes.";
    } else {
      $scope.placeholder_text = "";
    }
  });

  /**
   * Music genres and the value that will be sent on the API.
   *
   * @type {{name: string, value: string}[]}
   */
  $scope.genre_choices = [/*
    { name: 'Classical', value: 'com.twilio.music.classical' },
    { name: 'Coldplay', value:'coldplay' },
    { name: 'Ambient', value: 'com.twilio.music.ambient' },
    { name: 'Electronica', value: 'com.twilio.music.electronica' },
    { name: 'Guitars', value: 'com.twilio.music.guitars' },
    { name: 'Rock', value: 'com.twilio.music.rock' },
    { name: 'Soft Rock', value: 'com.twilio.music.soft-rock' },
    { name: 'Beatles', value: 'beatles' },
    { name: 'Sergio Mendes', value: 'sergiomendes' },
    { name: 'Pink Floyd', value: 'floyd' }
  */];
  $http.get('/bridges/api/v1/hold-music-genres/?format=json')
    .then(function(r) {
      [].push.apply($scope.genre_choices, r.data.hold_music_genres.filter(function(g) {
        return g.active;
      }).map(function(g) {
        return {
          name: g.name,
          value: g.identifier,
          url: g.example_url,
        };
      }));
    });

  $scope.getMusicChoice = function() {
    return $scope.genre_choices.filter(function(c) {
      return c.value === $scope.MODEL.music_choice;
    })[0];
  };

  $scope.restoreForm = function($event) {
    $event.preventDefault();
    $route.reload();
  };

  $scope.$watch('MODEL', function(newVal, oldVal){
    if (!angular.equals(newVal, oldVal)) {
      $scope.MODIFIED = true;
    }
  }, true);

  $scope.$on('$locationChangeStart', function (event, next, current) {
    if(!$scope.MODIFIED) {
      return;
    }

    event.preventDefault();
    $("#confirmationUpdate").modal('show');
    $scope.next = next;
  });

  $scope.exitWithoutSave = function($event) {
    $event.preventDefault();
    $scope.goNext();
  };

  $scope.goNext = function() {
    if(!$scope.next) {
      return;
    }

    $scope.MODIFIED = false;
    $scope.hideModal('confirmationUpdate');
    $window.location.replace($scope.next);
  };

  $scope.hideModal = function(modal) {
    $("#"+modal).modal('hide');
    $('.modal-backdrop').remove();
  };

  $scope.openCopyLineSettings = function($event) {
    $event.preventDefault();
    $('#lineConfigSettingsModal').modal('show');
  };

  $scope.closeCopyLineSettings = function($event) {
    $event.preventDefault();
    $('#lineConfigSettingsModal').modal('hide');
  };

  $scope.selectCopyFrom = function($event, from) {
    $event.preventDefault();
    $scope.selectedCopyFrom = true;
    $scope.copyFrom = from;
  };

  $scope.copyConfigLine = function($event) {
    $event.preventDefault();

    if ($scope.selectedCopyFrom) {
      var data = $.param({
        number: $scope.number,
        extract: $scope.copyFrom
      });

      $http.post('/bridges/api/v1/copy-config-line', data, {
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
      }).then(function() {
        $window.location.reload();
      }, function() {
        console.log("error config line");
      });
    }
  };

  $scope.pinlist_uploadFile = function() {
    var file = $scope.pinlist_file[0];
    var isCSVFile = file.type.match(/application\/vnd.ms-excel/i) || file.name.match(/\.csv$/i);

    var fd = new window.FormData();
    fd.append((isCSVFile ? 'csv' : 'xlsx') + '_file', file);

    $scope.pinlist_loading = true;
    var eventId = {'7776': 34, '5718': 34}[company.id+''] || 81;
    $http.post('/bridges/api/v1/upload_pins_for_scheduled_event/'+eventId+'/' + $scope.MODEL.id, fd, uploadHeaders).then(function(response) {
      Toast.notify("File uploaded successfully!");
      Toast.notify(response.data.message);
      $scope.pinlist_modal.modal('hide');
    }, function(err) {
      $scope.pinlist_uploadError = err.data.message;
    }).then(function() {
      $scope.pinlist_loading = false;
    });
  };

  (function() {
    // easter egg
    var keysq = [], tot;
    document.addEventListener('keyup', function eastereggfn(e) {
      if (e.shiftKey) {
        keysq.push(e.key);
        clearTimeout(tot);
      }

      if (keysq.join('').toLowerCase() === 'play') {
        sessionStorage.setItem('AifConsauyhPeeeldneroocwr', true);
        Toast.notify('In conference audio player enabled!');
        document.removeEventListener('keyup', eastereggfn);
      }

      tot = setTimeout(function() {
        keysq = [];
      }, 2000);
    });
  })();
}



/*****************
 ** WEBPACK FOOTER
 ** ./app/modules/line-settings/line-settings.controller.js
 ** module id = 348
 ** module chunks = 0
 **/